module.exports = __webpack_public_path__ + "img/play.d6bff316.svg";